// 原版
// export function extractJSON(str) {
// 	var firstOpen, firstClose, candidate;
// 	firstOpen = str.indexOf('{', firstOpen + 1);
// 	do {
// 		firstClose = str.lastIndexOf('}');
// 		console.log('firstOpen: ' + firstOpen, 'firstClose: ' + firstClose);
// 		if (firstClose <= firstOpen) {
// 			return null;
// 		}
// 		do {
// 			candidate = str.substring(firstOpen, firstClose + 1);
// 			console.log('candidate: ' + candidate);
// 			try {
// 				var res = JSON.parse(candidate);
// 				console.log('...found');
// 				return [res, firstOpen, firstClose + 1];
// 			}
// 			catch (e) {
// 				console.log('...failed');
// 			}
// 			firstClose = str.substr(0, firstClose).lastIndexOf('}');
// 		} while (firstClose > firstOpen);
// 		firstOpen = str.indexOf('{', firstOpen + 1);
// 	} while (firstOpen != -1);
// }

function extract(str, starter, ender) {
	var firstOpen, firstClose, candidate;
	firstOpen = str.indexOf(starter, firstOpen + 1);
	do {
		firstClose = str.lastIndexOf(ender);
		if (firstClose <= firstOpen) {
			return '';
		}
		do {
			candidate = str.substring(firstOpen, firstClose + 1);
			try {
				JSON.parse(candidate);
				return candidate;
			}
			catch (e) {
			}
			firstClose = str.substr(0, firstClose).lastIndexOf(ender);
		} while (firstClose > firstOpen);
		firstOpen = str.indexOf(starter, firstOpen + 1);
	} while (firstOpen !== -1);
}

export function extractJSON(str) {
	var candidate = ''
	const json_by_large = extract(str, '{', '}');
	// console.log("json_by_large", json_by_large)
	if (json_by_large && json_by_large.length > candidate.length) {
		candidate = json_by_large
	}
	const json_by_middle = extract(str, '[', ']');
	// console.log("json_by_middle", json_by_middle)
	if (json_by_middle && json_by_middle.length > candidate.length) {
		candidate = json_by_middle
	}
	if (candidate.length <= 0) {
		return null;
	} else {
		return JSON.parse(candidate)
	}
}

export function extractMiddleJSON(str) {
	const json_by_middle = extract(str, '[', ']');
	if (json_by_middle && json_by_middle.length > 0) {
		return JSON.parse(json_by_middle);
	} else {
		return null;
	}
}

export function extractLargeJSON(str) {
	const json_by_large = extract(str, '{', '}');
	if (json_by_large && json_by_large.length > 0) {
		return JSON.parse(json_by_large);
	} else {
		return null;
	}
}